import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { MatterRun } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetMatterRuns = (matterId: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<MatterRun[]>(
    [QueryEntity.Runs, { matterId }],
    () => {
      return fetch(`${APIBaseChronos}/api/run/matter/${matterId}`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
